import React from "react";
import {Modal} from "@mui/material";
import {useViewController} from "data/services/locator";
import {IModalController} from "views/components/modals/modal.controller";
import {Bindings} from "data/constants/bindings";
import {ModalType} from "data/enums";
import {
	ModalButton,
	ModalCloseButton,
	ModalContent,
	ModalText,
	ModalTitle,
} from "views/components/modals/common";
import {observer} from "mobx-react";
import {ReactComponent as IconClose} from "assets/img/icons/close.svg";
import {ReactComponent as IconSuccess} from "assets/img/icons/modal-success-icon.svg";
import {useTranslation} from "react-i18next";

export const ModalPlayoff: React.FC = observer(() => {
	const {t} = useTranslation();
	const {isModalOpen, close} = useViewController<IModalController>(Bindings.ModalController);
	const isOpen = isModalOpen(ModalType.PLAYOFF);

	return (
		<Modal open={isOpen} onClose={close}>
			<ModalContent>
				<ModalCloseButton onClick={close}>
					<IconClose />
				</ModalCloseButton>
				<IconSuccess />

				<ModalTitle>{t("modals.playoff.title", "Welcome to the Playoffs!")}</ModalTitle>

				<ModalText>
					{t(
						"modals.playoff.text",
						"The stakes are higher, and so are the rewards! We’ve reset the contest for the postseason to give everyone a fresh start. Are you ready to claim the top spot and the new prizes up for grabs?"
					)}
				</ModalText>

				<ModalButton fullWidth onClick={close}>
					{t("modals.playoff.button", "Dive Into the Playoffs")}
				</ModalButton>
			</ModalContent>
		</Modal>
	);
});
